// Skills.js
import React from 'react';
//import SkillMeter from './Skillbar';
//import SkillsDisplay from './Skilldisplay';
import SkillsPage from './SkillsPage';

const Skills = () => {
  return (
    <div>
      <p><strong>Note: </strong> All the skills mentioned below are rated for entry-level positions out of 100 and are subject to the required preparation time, which depends on the skill set (2 to 14 days) for better, detailed, and precise answers. A prior notice from the company regarding which skills they focus on would be appreciated.</p>
      <a href="#skills" style={{ textDecoration: 'none' }}> < SkillsPage /></a>
    </div>
  );
};

export default Skills;
